/**
 * Traditional Chinese → Simplified Chinese conversion engine
 * Based on OpenCC standard character mapping
 */

const TRAD_TO_SIMP_MAP: Record<string, string> = {
  // Common characters
  著: '着',
  開: '开',
  關: '关',
  門: '门',
  們: '们',
  學: '学',
  習: '习',
  認: '认',
  識: '识',
  對: '对',
  電: '电',
  腦: '脑',
  時: '时',
  間: '间',
  現: '现',
  實: '实',
  體: '体',
  會: '会',
  個: '个',
  為: '为',
  沒: '没',
  說: '说',
  話: '话',
  問: '问',
  題: '题',
  這: '这',
  裡: '里',
  從: '从',
  來: '来',
  過: '过',
  還: '还',
  種: '种',
  應: '应',
  讓: '让',
  進: '进',
  頭: '头',
  發: '发',
  長: '长',
  後: '后',
  樣: '样',
  動: '动',
  機: '机',
  業: '业',
  東: '东',
  車: '车',
  見: '见',
  氣: '气',
  風: '风',
  愛: '爱',
  國: '国',
  經: '经',
  網: '网',
  給: '给',
  總: '总',
  結: '结',
  處: '处',
  萬: '万',
  點: '点',
  歷: '历',
  曆: '历',
  聲: '声',
  報: '报',
  團: '团',
  醫: '医',
  藥: '药',
  質: '质',
  標: '标',
  準: '准',
  務: '务',
  區: '区',
  號: '号',
  稱: '称',
  選: '选',
  擇: '择',
  際: '际',
  導: '导',
  遠: '远',
  視: '视',
  聽: '听',
  寫: '写',
  讀: '读',
  試: '试',
  驗: '验',
  變: '变',
  壓: '压',
  數: '数',
  據: '据',
  類: '类',
  難: '难',
  歡: '欢',
  樂: '乐',
  買: '买',
  賣: '卖',
  錯: '错',
  誤: '误',
  郵: '邮',
  飛: '飞',
  華: '华',
  衛: '卫',
  議: '议',
  廠: '厂',
  義: '义',
  龍: '龙',
  魚: '鱼',
  鳥: '鸟',
  馬: '马',
  黃: '黄',
  邊: '边',
  與: '与',
  興: '兴',
  舉: '举',
  舊: '旧',
  書: '书',
  畫: '画',
  當: '当',
  專: '专',
  確: '确',
  單: '单',
  參: '参',
  優: '优',
  戰: '战',
  聯: '联',
  達: '达',
  運: '运',
  轉: '转',
  線: '线',
  統: '统',
  計: '计',
  設: '设',
  許: '许',
  調: '调',
  謝: '谢',
  記: '记',
  證: '证',
  該: '该',
  誰: '谁',
  請: '请',
  論: '论',
  費: '费',
  資: '资',
  賓: '宾',
  責: '责',
  貿: '贸',
  賀: '贺',
  寶: '宝',
  審: '审',
  寬: '宽',
  將: '将',
  尋: '寻',
  層: '层',
  屬: '属',
  歲: '岁',
  島: '岛',
  嶼: '屿',
  峽: '峡',
  嶺: '岭',
  嶽: '岳',
  巒: '峦',
  師: '师',
  帶: '带',
  幫: '帮',
  幹: '干',
  幾: '几',
  廣: '广',
  廳: '厅',
  慶: '庆',
  庫: '库',
  廁: '厕',
  廂: '厢',
  廈: '厦',
  廄: '厩',
  廟: '庙',
  廬: '庐',
  廢: '废',
  異: '异',
  棄: '弃',
  弔: '吊',
  張: '张',
  強: '强',
  彈: '弹',
  彌: '弥',
  彎: '弯',
  歸: '归',
  錄: '录',
  復: '复',
  複: '复',
  覆: '复',
  術: '术',
  衝: '冲',
  徹: '彻',
  徵: '征',
  製: '制',
  褲: '裤',
  鬱: '郁',
  鬆: '松',
  麵: '面',
  鬍: '胡',
  鬚: '须',
  鬥: '斗',
  鬧: '闹',
  鯊: '鲨',
  鯨: '鲸',
  鯉: '鲤',
  鯽: '鲫',
  鰻: '鳗',
  鱷: '鳄',
  魯: '鲁',
  鮮: '鲜',
  鳩: '鸠',
  鳴: '鸣',
  鷗: '鸥',
  鴨: '鸭',
  鷹: '鹰',
  鸚: '鹦',
  鹼: '碱',
  鹽: '盐',
  麗: '丽',
  麥: '麦',
  黴: '霉',
  點: '点',
  齊: '齐',
  齒: '齿',
  齡: '龄',
  龜: '龟',
  僅: '仅',
  儘: '尽',
  盡: '尽',
  傳: '传',
  傷: '伤',
  億: '亿',
  價: '价',
  儀: '仪',
  儂: '侬',
  償: '偿',
  儲: '储',
  兒: '儿',
  黨: '党',
  內: '内',
  兩: '两',
  冊: '册',
  凍: '冻',
  決: '决',
  況: '况',
  淨: '净',
  涼: '凉',
  湊: '凑',
  減: '减',
  匯: '汇',
  劉: '刘',
  則: '则',
  創: '创',
  勞: '劳',
  勢: '势',
  勵: '励',
  勸: '劝',
  協: '协',
  博: '博',
  卻: '却',
  厭: '厌',
  厲: '厉',
  縣: '县',
  臺: '台',
  颱: '台',
  檯: '台',
  葉: '叶',
  嘆: '叹',
  嗎: '吗',
  嗚: '呜',
  嚇: '吓',
  員: '员',
  唄: '呗',
  啟: '启',
  啞: '哑',
  圍: '围',
  園: '园',
  圓: '圆',
  圖: '图',
  場: '场',
  塊: '块',
  塵: '尘',
  夢: '梦',
  夥: '伙',
  夠: '够',
  奮: '奋',
  婦: '妇',
  妝: '妆',
  媽: '妈',
  嫻: '娴',
  孫: '孙',
  寧: '宁',
  寵: '宠',
  憲: '宪',
  嘗: '尝',
  奪: '夺',
  獎: '奖',
  奧: '奥',
  尷: '尴',
  尬: '尬',
  屍: '尸',
  屢: '屡',
  帳: '帐',
  幀: '帧',
  延: '延',
  建: '建',
  弄: '弄',
  彥: '彦',
  彩: '彩',
  彭: '彭',
  影: '影',
  微: '微',
  德: '德',
  鬥: '斗',
  鬱: '郁',
  黴: '霉',
};

/** Convert a single Traditional Chinese character to Simplified */
function tradCharToSimp(char: string): string {
  return TRAD_TO_SIMP_MAP[char] || char;
}

/** Convert a Traditional Chinese string to Simplified Chinese */
export function toSimplified(text: string): string {
  if (!text) return text;
  return text.split('').map(tradCharToSimp).join('');
}